import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonYpsiliRight';
const args = {};

export class OligonYpsiliRight extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
